// src/components/modals/GigDetailModal.jsx
// Gig Detail / View Playlist modal — extracted 1:1 from original App.jsx

import React from 'react';
import { X } from 'lucide-react';
import { markAsInterested, unmarkAsInterested } from '../../firebase-utils';

export default function GigDetailModal({
  show,
  onClose,
  selectedGig,
  interestedGigs,
  setInterestedGigs,
  currentUser,
  setShowAuthModal,
}) {
  if (!show || !selectedGig) return null;

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="rock-background gig-card border-2 border-electric max-w-3xl w-full h-[90vh] flex flex-col">

        {/* HEADER */}
        <div className="flex justify-end items-center p-4 flex-shrink-0">
          <button
            onClick={onClose}
            className="text-white hover:text-red-400 p-2 touch-target"
          >
            <X size={32} />
          </button>
        </div>

        {/* BODY - Scrollable */}
        <div className="flex-1 overflow-y-auto p-6">

          {/* Setlist Preview */}
          <div className="bg-white/5 border border-white/10 rounded-xl p-6 mb-6">
            <h3 className="text-base md:text-lg text-magenta mb-4 font-bold whitespace-nowrap text-center">
              🎵 EXPECTED SETLIST
            </h3>
            {(() => {
              let displaySongs = [];
              const queueSize = selectedGig.maxQueueSize || selectedGig.queueSize || 20;
              const gigPlaylist = selectedGig.queuedSongs || [];
              const masterPlaylist = selectedGig.masterPlaylist || [];

              if (gigPlaylist.length > queueSize) {
                const shuffled = [...gigPlaylist].sort(() => Math.random() - 0.5);
                displaySongs = shuffled.slice(0, queueSize);
              } else if (gigPlaylist.length > 0 && gigPlaylist.length < queueSize) {
                displaySongs = [...gigPlaylist];
                const needed = queueSize - gigPlaylist.length;
                const available = masterPlaylist.filter(m => !gigPlaylist.find(g => g.id === m.id));
                const shuffled = [...available].sort(() => Math.random() - 0.5);
                displaySongs = [...displaySongs, ...shuffled.slice(0, needed)];
              } else if (gigPlaylist.length === 0) {
                const shuffled = [...masterPlaylist].sort(() => Math.random() - 0.5);
                displaySongs = shuffled.slice(0, queueSize);
              } else {
                displaySongs = gigPlaylist;
              }

              const playlistType = gigPlaylist.length > 0 ? 'Curated Queue' : 'Master Playlist';

              return displaySongs.length > 0 ? (
                <>
                  <p className="text-electric text-sm mb-4 font-semibold">
                    Showing: {playlistType} ({displaySongs.length}/{queueSize} songs)
                  </p>
                  <div className="space-y-2">
                    {displaySongs.map((song, index) => {
                      if (!song || !song.title) return null;
                      return (
                        <div
                          key={song.id || index}
                          className="bg-white/5 p-3 rounded-lg flex items-center gap-3 hover:bg-white/10 transition border border-white/10"
                        >
                          <span className="concert-heading text-electric text-xl min-w-[40px]">
                            {index + 1}
                          </span>
                          <div className="flex-1 min-w-0">
                            <div className="text-white font-bold truncate">{song.title}</div>
                            <div className="text-gray-light text-sm truncate">{song.artist || 'Unknown Artist'}</div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <p className="text-gray text-sm mt-4 italic text-center">
                    {displaySongs.length} song{displaySongs.length !== 1 ? 's' : ''} • Final setlist may vary
                  </p>
                </>
              ) : (
                <div className="bg-white/5 rounded-lg p-8 text-center border border-electric/30">
                  <p className="text-gray-light">
                    Setlist not available yet. Check back closer to showtime! 🎸
                  </p>
                </div>
              );
            })()}
          </div>
        </div>

        {/* FOOTER */}
        <div className="p-6 pt-4 border-t border-white/10 flex-shrink-0">
          <div className="flex flex-row gap-3 justify-center">
            <button
              onClick={async () => {
                if (!currentUser) {
                  setShowAuthModal(true);
                  return;
                }
                const isCurrentlyInterested = interestedGigs.includes(selectedGig.id);
                try {
                  if (isCurrentlyInterested) {
                    await unmarkAsInterested(selectedGig.id, currentUser.uid);
                    setInterestedGigs(interestedGigs.filter(id => id !== selectedGig.id));
                  } else {
                    await markAsInterested(selectedGig.id, currentUser.uid);
                    setInterestedGigs([...interestedGigs, selectedGig.id]);
                  }
                } catch (error) {
                  alert('Error updating interest: ' + error.message);
                }
              }}
              className={`btn text-sm md:text-base px-4 ${
                interestedGigs.includes(selectedGig.id) ? 'btn-neon' : 'btn-electric'
              }`}
            >
              <span>⭐</span>
              <span>{interestedGigs.includes(selectedGig.id) ? 'Mark As Interested' : 'Mark as Interested'}</span>
            </button>
            <button
              onClick={onClose}
              className="btn btn-ghost text-sm md:text-base px-6"
            >
              Close
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}
